export const calendar = {
    head: 'Calendar',
    monthAppt: 'Monthly Appointments',
    date: 'Date',
    time: 'Time',
    from: 'From',
    status: 'Status',
    consultant: 'Consultant',
    productType: 'Product',
    noApptSrc: 'assets/images/backgrounds/data.png',

    deleteConfirm: 'Are you sure you want to delete?',
    deleteHead: 'Confirm',
    deleteOk: 'Yes',
    deleteCancel: 'No',

    startDate: 'Start Date',
    startTime: 'Start Time',
    endTime: 'End Time',
    consultantPlace: 'Consultant',
    notes: 'Notes',
    update: 'Update',
    delete: 'Delete',
    editTitle: 'Assign to Pro',
    timeMismatch: 'Start and End time should be different',
    dataMisMatch: 'Start date must be less than end date',
    noPro: 'No pro user',
    customer: 'Customer',
    product: 'Product',
    Ordered: 'Ordered on',
    dueDate: 'Due date & time:',

    // View popup
    viewHeading: 'View Details',
    ViewFrom: 'From',
    apptOn: ' Appointment on',
    role: 'Role',
    viewStatus: 'Status',
    viewNotes: 'Notes',
    okText: 'OK',
    cancelText: 'CANCEL'
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/calendar.ts